import { Injectable } from '@angular/core';
import axios from 'axios';

import { TokenPrefixEnum } from '@app/core/auth/auth.model';
import { UserDataEnum } from '@app/core/auth/user.model';
import { TokenService } from '@app/auth/token.service';
import { UserService } from '@app/auth/user.service';
import { environment } from '@env/environment';

import {
  ConsentDTO,
  TransmissionSharingDTO
} from '../consents/services/opin-consent/opin-consent.model';
import { OpinConsentService } from '../consents/services/opin-consent/opin-consent.service';

import { ReceiverConsent } from './consent-management.model';

@Injectable({
  providedIn: 'root'
})
export class ConsentManagementService {
  private readonly api = axios.create({
    baseURL: `${environment.opin.api_opin}/opin-consent`
  });

  API_OPIN = environment.opin.api_opin;

  constructor(
    private readonly userService: UserService,
    private readonly opinConsentService: OpinConsentService,
    private tokenService: TokenService
  ) {}

  async getSentSharings(): Promise<TransmissionSharingDTO[]> {
    const cpf = this.userService.getUserData(UserDataEnum.Cpf);
    const tokenUsuario = this.tokenService.getToken(TokenPrefixEnum.Bearer);

    const consents =
      await this.opinConsentService.fetchTransmissionConsentManage(
        cpf,
        tokenUsuario
      );

    return consents;
  }

  async getReceivedSharings(): Promise<ReceiverConsent[]> {
    const userToken = this.tokenService.getToken(TokenPrefixEnum.Bearer);
    const consents = await this.fetchReceivedConsentManage(userToken);

    return consents;
  }

  async getSharingById(consent_id: string): Promise<ConsentDTO> {
    const userToken = this.tokenService.getToken(TokenPrefixEnum.Bearer);

    const consent =
      await this.opinConsentService.getTransmissionManagementConsentById(
        consent_id,
        userToken
      );

    return consent;
  }

  async revokeTransmissionConsentByID(consentID: string): Promise<void> {
    const userToken = this.tokenService.getToken(TokenPrefixEnum.Bearer);

    await this.opinConsentService.revokeTransmissionConsent(
      consentID,
      userToken
    );
  }

  async revokeReceptionConsentByID(consentID: string): Promise<void> {
    const userToken = this.tokenService.getToken(TokenPrefixEnum.Bearer);

    await this.opinConsentService.revokeReceptionConsent(consentID, userToken);
  }

  async fetchReceivedConsentManage(token: string): Promise<ReceiverConsent[]> {
    const { data: consents } = await this.api.get<ReceiverConsent[]>(
      `/reception-management/consents-received`,
      {
        headers: {
          Authorization: token
        }
      }
    );

    return consents;
  }

  async getReceveidConsentById(
    token: string,
    consentId: string
  ): Promise<ReceiverConsent> {
    const { data: consent } = await this.api.get<ReceiverConsent>(
      `/reception-management/consents-received/${consentId}`,
      {
        headers: {
          Authorization: token
        }
      }
    );

    return consent;
  }
}
